<mat-menu [overlapTrigger]="false" class="qv-menu">
  <button (click)="onMenuItemClick(menuItem)"
          *ngFor="let menuItem of menuItems"
          [class.qv-menu__item--active]="control.value?.id === menuItem.id"
          class="qv-menu__item"
          mat-menu-item
  >{{ menuItem.name }}
  </button>
</mat-menu>
